import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { fetchCompanyPSICS, fetchPSICS } from "../api/api";
import LoadingErrorWrapper from "../api/LoadingErrorWrapper";

import TabOverviewSelector from "../components/redesign/portfolio_impact/TabOverviewSelector";
import PsicsTabGeographics from "../components/redesign/psics/PsicsTabGeographic";
import PsicsTabProducts from "../components/redesign/psics/PsicsTabProducts";
import NoComparisonData from "../components/redesign/NoComparisonData";

import TopTab from "../components/redesign/psics/TopTab";
import { useDataContext } from "../context/PortfolioContext";
import { AllRoutes } from "./Routes";

const CompanyPSICS = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { selectedCompanies } = useDataContext();

  const [compareWithIndustry, setCompareWithIndustry] = useState(false);

  const tabs = [{ name: "Products & Services (PSICS)" }, { name: "Geography" }];

  const handleTabChange = (tab) => {
    setActiveTab((prev) => tab);
  };

  const toggleSplitView = () => {
    setCompareWithIndustry((prev) => !prev);
  };

  const {
    year,
    companyList,
    setAllYears,
    setCompanyList,
    setSelectedCompanies,
    setResponse,
    setCurrentType,
    handleClearData,
    isCompanyData,
  } = useDataContext();

  const { isLoading, error, data } = useQuery(
    ["company_psics", selectedCompanies, year],
    () => {
      return fetchCompanyPSICS(selectedCompanies, year);
    }
  );

  useEffect(() => {
    /*   console.log("torolem");
    handleClearData(); */

    if (data) {
      setCompanyList(
        data?.data.map((c) => ({
          name: c.portfolioName,
          percentage: c.transparencyScore * 100,
          value: c.totalValue[year],
        }))
      );
      setAllYears(
        Object.keys(data?.data?.[0].totalValue)
          .map((i, idx) => ({
            id: idx,
            name: `${i}`,
          }))
          .reverse()
      );
      setResponse(data);
      setCurrentType(AllRoutes.company_psics);
    } else {
      if (!isCompanyData()) {
        setSelectedCompanies([]);
        setCompanyList([]);
      }
    }
  }, [data, year]);

  if (isLoading || error)
    return <LoadingErrorWrapper isLoading={isLoading} error={error} />;

  return (
    <div className="w-full flex flex-col gap-y-8 pt-3" id="company_psics">
      <div className="px-8 flex flex-col gap-y-8">
        <TabOverviewSelector
          title={tabs[activeTab].name}
          onExport={"company_psics"}
          splitView={compareWithIndustry}
          splitToggle={toggleSplitView}
        />
        {selectedCompanies.length != 1 ? (
          <NoComparisonData />
        ) : (
          <>
            {activeTab == 0 && (
              <PsicsTabProducts
                key={`TAB_${compareWithIndustry.toString()}`}
                splitView={compareWithIndustry}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CompanyPSICS;
